import { Component, OnInit, Input, Output, EventEmitter, Inject, ɵConsole } from '@angular/core';
import { GipUserEditForm, GipUserPostModel, GipUserUpdateModel, GipUserUpdateRoleModel } from 'src/app/workflow/user/gipUserEdit/gipUserEdit.model';
import { FormularService } from 'src/app/Services/formular.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import { FormControlName } from '@angular/forms';
import { AdminService } from 'src/app/workflow/admin/admin.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { UserService } from '../../user.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'gipUserForm',
  templateUrl: './gipUserForm.component.html',
  styleUrls: ['./gipUserForm.component.css']
})
export class GipUserFormComponent implements OnInit {

  constructor(private formularService: FormularService,
    private route: ActivatedRoute,
    private router: Router,
    private shareData: SharingDataService,
    private authService: AuthentService,
    public adminService: AdminService,
    public dialog: MatDialog,
    public userService: UserService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private toPicklist: ToPicklistPipe,
    private fromPicklist: FromPicklistPipe,
  ) { }

  modelInput = GipUserEditForm;
  id;
  isEdit;
  isNew;
  resourceDefinition;
  showLoading = true;
  Language;
  currentUser;
  displayUser;
  picklist;
  role = this.authService.currentUser().ROLE;
  groupName="V_MS_USER";
  contract;

  formular = [
    { formControlName: "ROLES", hidden: true, listOfValues: [], newReadonly: true, editReadonly: true, required: true},
    { formControlName: "USERGUID", hidden: true, readonly: true, newReadonly: true, editReadonly: true, newRow: true },
    { formControlName: "APPLICATION", hidden: true, newReadonly: false, editReadonly: false },
    { formControlName: "LOGIN", hidden: true, newReadonly: false, editReadonly: false },
    { formControlName: "SALUTION", picklist: "V_MS_SALUTATION_VL_T", required: true, newReadonly: false, editReadonly: false, newRow: true },
    { formControlName: "TITLE", picklist: "V_MS_TITLE_VL_T", newReadonly: false, editReadonly: false, canEmptyValue: true},
    { formControlName: "NAME", required: true, inputString: true, newReadonly: false, editReadonly: false, newRow: true },
    { formControlName: "SURNAME", required: true, inputString: true, newReadonly: false, editReadonly: false },
    { formControlName: "EMAIL", required: true, inputString: true, newReadonly: false, editReadonly: false, newRow: true },
    { formControlName: "PHONE", inputString: true, newReadonly: false, editReadonly: false },
    { formControlName: "ACCEPTED", hidden: true, inputString: true, newReadonly: false, editReadonly: false },

    { formControlName: "COMPANY_NAME", hidden: true, required: true, modalWindow: true, newReadonly: false, editReadonly: false, newRow: true, function: "companyIdModalWindow" },
    { formControlName: "CONTRACT_NAME", hidden: true, required: true, modalWindow: true, newReadonly: false, editReadonly: false, newRow: true, function: "contractIdModalWindow" },
    { formControlName: "VERIFIED", hidden: true, newRow: true, required: true, checkbox: true, newReadonly: true, editReadonly: true },
    { formControlName: "LOCKED", hidden: true, newRow: true, required: true, checkbox: true, newReadonly: true, editReadonly: true },
    

    { formControlName: "btn_back", hidden: true, button: true, function: "btnBackAction", type: "button", newRow: true },
    { formControlName: "btn_save", hidden: false, button: true, function: "btnSaveAction", type: "submit" },
    { formControlName: "btn_newpwd", hidden: true, button: true, function: "btnNewPwdAction", type: "button" },
  ]

  ngOnInit(): void {
    this.modelInput.reset();
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe((data) => this.Language = data);
    this.shareData.currentPicklist.subscribe((data) => this.picklist = data);
    this.shareData.currentUser.subscribe((data) => {
      this.currentUser = data;
      if(this.currentUser != null){
        this.getUrlParams();
      }
    });
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.id != undefined) {
          this.id = params.id;
          this.setReadonly();
        } else {
          this.changeToNew();
        }
        if (params.isEdit != undefined) {
          this.isEdit = params.isEdit;
          this.setReadonly();
        }
        if (this.router.url == '/currentUser'){
          this.isEdit = true;
          this.isNew = false;
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin) {
          this.externalOnInit();
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.InternalUser) {
          this.internalOnInit();
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser || this.authService.currentUser().ROLE == AuthenticationRole.Public) {
          this.publicOnInit();
        }
      });
  }

  externalOnInit() {
    this.formular.forEach(element => {
      if (this.isEdit) {
        if (element.formControlName == "ROLES") { element.hidden = false; element.readonly = true; }
        if (element.formControlName == "COMPANY_MID") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false;}
        if (element.formControlName == "COMPANY_NAME") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false; }
        if (element.formControlName == "CONTRACT") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false;}
        if (element.formControlName == "CONTRACT_NAME") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false;}
        if (this.router.url != '/currentUser') {
          if (element.formControlName == "VERIFIED") { element.hidden = false; element.readonly = false; }
          if (element.formControlName == "LOCKED") { element.hidden = false; element.readonly = false }
          if (element.formControlName == "btn_back") { element.hidden = false; }
          if (element.formControlName == "btn_newpwd") { element.hidden = false; }
        }
        else {
          if (element.formControlName == "btn_save") { element.newRow = true; }
        }
      }

      if (this.isNew) {
        if (element.formControlName == "ROLES") { element.hidden = false; element.readonly = true; }
        if (element.formControlName == "COMPANY_MID") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false;}
        if (element.formControlName == "COMPANY_NAME") { element.hidden = false; element.readonly = true; }
        if (element.formControlName == "CONTRACT") { element.hidden = false; element.readonly = true; element.inputString = true; element.modalWindow = false;}
        if (element.formControlName == "CONTRACT_NAME") { element.hidden = false; element.readonly = true; }
        if (element.formControlName == "VERIFIED") { element.hidden = false; element.readonly = false; }
        if (element.formControlName == "LOCKED") { element.hidden = false; element.readonly = false; }
        if (this.router.url != '/currentUser') {
          if (element.formControlName == "btn_back") { element.hidden = false; }
        }
        else {
          if (element.formControlName == "btn_save") { element.newRow = true; }
        }
        this.modelInput.reset();
        this.modelInput.controls.APPLICATION.setValue("GIP_AUSKUNFT");
        this.modelInput.controls.LOGIN.setValue("NULL");
        this.modelInput.controls.CONTRACT.setValue(this.currentUser.CONTRACT);
        this.modelInput.controls.CONTRACT_NAME.setValue(this.currentUser.CONTRACT_NAME);
        this.modelInput.controls.COMPANY_MID.setValue(this.currentUser.COMPANY_MID);
        this.modelInput.controls.COMPANY_NAME.setValue(this.currentUser.COMPANY_NAME);
        this.modelInput.controls.VERIFIED.setValue("1");
        this.modelInput.controls.LOCKED.setValue("0");
      }
    });
    if (this.router.url === '/currentUser') {
      this.getData(this.currentUser.USERGUID);
    } else {
      this.getData(this.id);
    }
  }

  internalOnInit() {
    this.formular.forEach(element => {
      if (this.isEdit) {
        if (element.formControlName == "COMPANY_MID") { element.hidden = false; }
        if (element.formControlName == "COMPANY_NAME") { element.hidden = false;}
        if (element.formControlName == "CONTRACT") { element.hidden = false; }
        if (element.formControlName == "CONTRACT_NAME") { element.hidden = false;}
        if (element.formControlName == "ROLES") { element.hidden = false; element.readonly = false }
        if (this.router.url != '/currentUser') {
          if (element.formControlName == "VERIFIED") { element.hidden = false; element.readonly = false; }
          if (element.formControlName == "LOCKED") { element.hidden = false; element.readonly = false }
          if (element.formControlName == "btn_back") { element.hidden = false; }
          if (element.formControlName == "btn_newpwd") { element.hidden = false; }
        }
        else {
          if (element.formControlName == "btn_save") { element.newRow = true; }
        }
      }

      if (this.isNew) {
        if (element.formControlName == "COMPANY_MID") { element.hidden = false; }
        if (element.formControlName == "COMPANY_NAME") { element.hidden = false; }
        if (element.formControlName == "CONTRACT") { element.hidden = false; }
        if (element.formControlName == "CONTRACT_NAME") { element.hidden = false; }
        if (element.formControlName == "ROLES") { element.hidden = false; element.readonly = false;}
        if (this.router.url != '/currentUser') {
          if (element.formControlName == "btn_back") { element.hidden = false; }
        }
        else {
          if (element.formControlName == "btn_save") { element.newRow = true; }
        }
        this.modelInput.reset();
        this.modelInput.controls.LOGIN.setValue("NULLL");
        this.modelInput.controls.APPLICATION.setValue("GIP_AUSKUNFT");
        this.modelInput.controls.VERIFIED.setValue("1");
        this.modelInput.controls.LOCKED.setValue("0");
      }
    });
    if (this.router.url === '/currentUser') {
      this.getData(this.currentUser.USERGUID);
    } else {
      this.getData(this.id);
    }
  }

  publicOnInit() {
    this.formular.forEach(element => {
      if (element.formControlName == "btn_save") { element.newRow = true; }
    });
    this.changeToEdit();
    this.getData(this.currentUser.USERGUID);
  }

  action(action) {
    this[action]();
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }


  changeToEdit() {
    this.isNew = false;
    this.isEdit = true;
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay() {
    this.isNew = false;
    this.isEdit = false;
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.isNew = true;
    this.isEdit = false;
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  btnBackAction() {
    this.router.navigate(["/gipUserList"]);
  }

  getData(id) {
    let urls = [
      `Admin/V_MS_USER?$filter=USERGUID eq '${id}'`,
      `Metadata/V_GIP_ROLE_CTRL?$filter=SROLE eq '${this.authService.currentUser().ROLE}' AND LANG eq '${this.Language}'`,
      `admin/MS_CONTRACT?$filter=ID eq ${this.currentUser.CONTRACT}`,
    ];
    let data = this.formularService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        this.displayUser = data[0][0];
        for (var dataElement in data[0][0]) {
          if (this.modelInput.controls[dataElement]) {
            if(dataElement == "ROLES"){
              this.modelInput.controls[dataElement].setValue(this.toPicklist.transform(data[0][0][dataElement], this.picklist.GIP_ROLE_T));
            } else {
              this.modelInput.controls[dataElement].setValue(data[0][0][dataElement]);
            }
          }
        }
        if(((this.authService.currentUser().ROLE == AuthenticationRole.InternalUser && (data[0][0].ROLES == AuthenticationRole.InternalAdmin || data[0][0].ROLES == AuthenticationRole.InternalUser)) || 
        (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin && (data[0][0].ROLES == AuthenticationRole.ExternalAdmin))) && this.router.url != '/currentUser'){
          this.formular.forEach(element => {
            element.readonly = true;
            if (element.formControlName == "btn_save") { element.hidden = true; }
            if (element.formControlName == "btn_newpwd") { element.hidden = true; }
          });
        }
        if(this.authService.currentUser().ROLE == AuthenticationRole.InternalUser){
          this.formular.forEach(element => {
            if(element.formControlName == "ROLES"){ element.readonly = true}
          });
        }
      }
      if(data[1][0] != undefined){
        const roleControl = data[1];
        if(this.isNew && this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin){
          this.modelInput.controls.ROLES.setValue(roleControl[0].DESCRIPT);
        }
        this.formular.forEach(element => {
          if(element.formControlName == "ROLES") {
            roleControl.forEach(roleElement => {
              element.listOfValues.push(roleElement.DESCRIPT)
            });
          }
        });
      }
      this.showLoading = false;
      this.formular.forEach(element => {
        if (element.checkbox) {
          this.modelInput.controls[element.formControlName].setValue(this.modelInput.value[element.formControlName] == "1" ? true : false)
        }
      });
      this.contract = data[2][0];
    });
  }

  companyIdModalWindow() {
    const dialogRef = this.dialog.open(companyIdDialog, {
      data: {company: this.modelInput.value.COMPANY_MID}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        var selectedRow = result
        this.modelInput.controls.COMPANY_MID.setValue(selectedRow.MID);
        this.modelInput.controls.COMPANY_NAME.setValue(selectedRow.COMPANY);
      }
    });
  }

  contractIdModalWindow() {
    const dialogRef = this.dialog.open(contractIdDialog, {
      data: {contract: this.modelInput.value.CONTRACT_NAME}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        var selectedRow = result
        this.modelInput.controls.CONTRACT.setValue(selectedRow.ID);
        this.modelInput.controls.CONTRACT_NAME.setValue(selectedRow.CONTRACT_NAME);
      }
    });
  }

  btnSaveAction() {
    if (this.router.url === '/currentUser') {
      this.updateData();
    } else {
      if (this.isNew) {
        this.postData();
      } else {
        this.updateData();
      }
    }
  }

  postData() {
    if (this.modelInput.status == "VALID") {
      this.showLoading = true;
      let model = new GipUserPostModel();
      model.fromFormGroupPostModel(this.modelInput);
      let roleModel = new GipUserUpdateRoleModel();
      roleModel.fromFormGroupUpdateRoleModel(this.modelInput);
      roleModel.ROLE = this.fromPicklist.transform(roleModel.ROLE, this.picklist.GIP_ROLE_T);
      model.ROLE.push(roleModel)
      this.formular.forEach(element => {
        if (element.checkbox) {
          model[element.formControlName] == true ? model[element.formControlName] = "1" : model[element.formControlName] = "0";
        }
      });
      this.adminService.postData("admin/MS_USER", model, (data) => {
        this.showLoading = false;
        this.btnBackAction();
      }, error => {
        this.btnBackAction();
      });
    }
  }

  updateData() {
    var date = new Date(this.contract.CONTRACT_EXPIRATION_DT);
    if(date < new Date()){
      this.errorHandlingService.showError(this.translateResourceDefinition.transform('isExpiredEx', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      return;
    }
    if (this.modelInput.status == "VALID") {
      this.showLoading = true;
      let model = new GipUserUpdateModel();
      model.fromFormGroupUpdateUserModel(this.modelInput);
      this.formular.forEach(element => {
        if (element.checkbox) {
          model[element.formControlName] == true ? model[element.formControlName] = "1" : model[element.formControlName] = "0";
        }
      });
      this.adminService.updateData("admin/MS_USER", model, model.getUpdateUser(), (userData) => {
        if (this.router.url != '/currentUser') {
          let roleModel = new GipUserUpdateRoleModel();
          roleModel.fromFormGroupUpdateRoleModel(this.modelInput);
          roleModel.ROLE = this.fromPicklist.transform(roleModel.ROLE, this.picklist.GIP_ROLE_T);
          this.adminService.updateData("admin/MS_USER_ROLE", roleModel, roleModel.getUpdateRole(), (roleData) => {
            this.btnBackAction();
          });
        } else {
          this.btnBackAction();
        }
      });
    }
  }

  btnNewPwdAction() {
    this.showLoading = true;
    var user = {
      EMAIL: "",
      LOGIN: "",}
      user.EMAIL = this.modelInput.value.EMAIL;
      user.LOGIN = this.modelInput.value.LOGIN;

      console.log(user);
      this.userService.postData(`portal/resetpwd?lang=${this.Language}`, user, (data) => {
        this.showLoading = false;
      }, (response) => {
        this.showLoading = false;
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      });
    }
  }


  @Component({
    selector: 'companyIdDialog',
    templateUrl: 'companyIdDialog.html',
  })
  export class companyIdDialog {
  resourceDefinition;
  selectedRow;
  PersonIDGrid;
  urlString;
  selectedKey="MID";
  defaultFilter;

  
  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef < companyIdDialog >,
    private formularService: FormularService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    let urls = [
      `Admin/MS_COMPANY?$filter=MID eq ${data.company}`,
    ];
    this.formularService.getData(urls, (company) => {
      this.selectedRow = company[0][0]?.MID;

      this.PersonIDGrid = [
        { name: "select",         visible: true,  enableFilter: false, enableOrderBy: false, export: false, type: "singleSelect",  enableSelect: true,   columnSearch: false, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "MID",            visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: false, fromToFilter: true, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "COMPANY",        visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "DESCRIPTION",    visible: false, enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "COUNTRY",        visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "ZIP_CODE",       visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: false, fromToFilter: true, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "CITY",           visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "STREET",         visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "HOUSE_NUMBER",   visible: true,  enableFilter: true,  enableOrderBy: true, export: false, type: "text",           enableSelect: true,   columnSearch: false, fromToFilter: true, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      ]

      this.urlString = "Admin/MS_COMPANY";
      this.defaultFilter = `UNUSED eq 0`;
      })
    };

    selectedRows;
    

  action(parameters){
    this[parameters.action](parameters.element, parameters.column, parameters.selectedSingleRows, parameters.selectedMultiRows);
  }

  Select(element, column, selectedSingleRows, selectedMultiRows){
    this.selectedRows = selectedSingleRows;
  }

  close() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'contractIdDialog',
  templateUrl: 'contractIdDialog.html',
})
export class contractIdDialog {
  resourceDefinition;
  PersonIDGrid
  selectedRow;
  urlString;
  defaultFilter;
  selectedKey="ID";
  groupName="MS_CONTRACT";

  constructor(
    private shareData: SharingDataService,
    private formularService: FormularService,
    public dialogRef: MatDialogRef<contractIdDialog>,
    public datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    var today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let urls = [
      `Admin/MS_CONTRACT?$filter=CONTRACT_NAME eq '${data.contract}'`,
    ];
    this.formularService.getData(urls, (contract) => {
      this.selectedRow = contract[0][0]?.ID;

      this.PersonIDGrid = [
        { name: "select",                   visible: true, enableFilter: false, enableOrderBy: false, export: false, type: "singleSelect",  enableSelect: true,   columnSearch: false, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "ID",                       visible: false, enableFilter: true,  enableOrderBy: true,  export: false, type: "text",          enableSelect: true,   columnSearch: false, fromToFilter: true,  picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "CONTRACT_NUMBER",          visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "text",          enableSelect: true,   columnSearch: true,  fromToFilter: false,  picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "CONTRACT_NAME",            visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "text",          enableSelect: true,   columnSearch: true,  fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "CONTRACT_EXPIRATION_DT",   visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "date",          enableSelect: true,   columnSearch: false, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "MAX_SHAPE_SIZE",           visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "number",        enableSelect: true,   columnSearch: false, fromToFilter: true,  picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
        { name: "MAX_NO_MAPSHEET_REQ",      visible: true, enableFilter: true,  enableOrderBy: true,  export: false, type: "text",          enableSelect: true,   columnSearch: false, fromToFilter: true, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      ]

      this.defaultFilter = `CONTRACT_EXPIRATION_DT ge ${today.toISOString()}`
      this.urlString = `Admin/MS_CONTRACT`
      })
    }

  selectedRows;  



  action(parameters){
    this[parameters.action](parameters.element, parameters.column, parameters.selectedSingleRows, parameters.selectedMultiRows);
  }

  Select(element, column, selectedSingleRows, selectedMultiRows){
    this.selectedRows = selectedSingleRows;
  }

  close() {
    this.dialogRef.close();
  }
}
